import { styled } from '@stitches/configed';
import { Image } from '../Image';
import AvatarPng from './avatar.png';

const AvatarStyled = styled('span', {
  display: 'block',
  border: '4px solid $brand',
  borderRadius: 100,
  width: 50,
  height: 50,
  img: {
    padding: 4,
    objectFit: 'cover',
    borderRadius: 100,
  },
});

type Props = {
  src?: string | null;
  size?: number;
};
const Avatar = ({ src, size }: Props) => {
  return (
    <AvatarStyled>
      <Image
        src={src ? src : AvatarPng}
        alt="Avatar"
        preview={false}
      />
    </AvatarStyled>
  );
};

export default Avatar;
